import { blogHomepageFeaturedArticles as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: 'Blog Spotlight',
  cardArr: [
    {
      key: '1',
      img: '/assets/textimageplaceholder.png',
      tags: [{ name: 'News', slug: 'news' }],
      headline: 'Ut ipsam error hic nobis totam aut commodi quasi ',
      url: 'https://www.engelvoelkers.com/en/',
      bodyText:
        'Sit tempore amet et laudantium vero in itaque praesentium et dignissimos assumenda cum harum veniam? ',
      alt_text: 'test image',
      date: '2022-04-08T23:58:27.316Z',
      backgroundColor: false,
    },
    {
      key: '2',
      img: '/assets/textimageplaceholder.png',
      tags: [{ name: 'News', slug: 'news' }],
      headline:
        'Est modi cupiditate est voluptas nihil aut impedit consequatur qui eius laudantium',
      url: 'https://www.engelvoelkers.com/en/',
      bodyText: 'Sed nemo laudantium qui ducimus quisquam ut dolorem velit et deserunt odit. ',
      alt_text: 'test image',
      date: '2022-03-29T20:08:30.477Z',
      backgroundColor: false,
    },
    {
      key: '3',
      img: '/assets/textimageplaceholder.png',
      tags: [{ name: 'News', slug: 'news' }],
      headline: 'Ut ipsam error hic nobis totam aut commodi quasi ',
      url: 'https://www.engelvoelkers.com/en/',
      bodyText: 'Aut pariatur mollitia et dolor repudiandae aut quia laudantium sit modi suscipit.',
      alt_text: 'test image',
      date: '2022-07-11T14:48:53.656Z',
      backgroundColor: false,
    },
  ],
};

export default fakeProps(schema, TestData);
